module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin fld"
  }, [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "cx-loading-md"
  })]) : _c('div', {
    staticClass: "wn-pad"
  }, [_c('div', {
    staticClass: "row fld",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.viewOne) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-12"
  }, [(Object.keys(_vm.cninsurance_account_forms).length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My InsureMoto")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('renew', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Renew Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('forms', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Submitted Forms")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Filed Claims")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMainView('complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Filed Complaints")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((_vm.cninsurance_account.cninsurance_account_cninsurance_data && _vm.cninsurance_account.cninsurance_account_cninsurance_data.cninsurance_name != '')) ? _c('div', [_c('h3', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.cninsurance_account.cninsurance_account_cninsurance_data.cninsurance_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "background-white p30 mb30 wn-pad0"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.set_main_view.complaints) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "background-color": "#ffffff"
    }
  }, [_c('h4', [_vm._v("View Complaints")]), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_complaints).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(_vm.cclaim.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_complaint', _vm.cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Complaints")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.claims) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "background-color": "#ffffff"
    }
  }, [_c('h4', [_vm._v("View Claims")]), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_claims).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_claim', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Claims")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.forms) ? _c('div', [_c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Forms (" + _vm._s((Object.keys(_vm.cninsurance_account_forms).length)) + ")")]), _vm._v(" "), (_vm.cninsurance_account_unsubmitted_forms > 0) ? _c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Not Submitted (" + _vm._s(_vm.cninsurance_account_unsubmitted_forms) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cninsurance_account_unpaid_forms > 0) ? _c('h4', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Not yet Paid for (" + _vm._s(_vm.cninsurance_account_unpaid_forms) + ")")]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.cninsurance_account_forms).length !== 0)) ? _c('div', _vm._l((_vm.cninsurance_account_forms), function(form, fndex) {
    return _c('div', [_c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-card-block",
      staticStyle: {
        "border": "1px solid #22baae",
        "margin-bottom": "1em",
        "padding": "0.2em",
        "border-radius": "2px"
      }
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('p', {
      staticStyle: {
        "color": "#22baae"
      }
    }, [_vm._v(_vm._s(form.form_details))])]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-bottom": "#22baae solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_form', form, '')
        }
      }
    }, [_vm._v("Check Status")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10",
      staticStyle: {
        "padding-left": "1.5em",
        "padding-top": "1em"
      }
    }, [(form.cninsurance_form_policy_id == 'nil') ? _c('p', [_c('b', [_vm._v("Form Policy Id:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Not assigned")])]) : _c('p', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('b', [_vm._v("Form Policy Id:")]), _vm._v(" " + _vm._s(form.cninsurance_form_policy_id))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("InsureMoto Id:")]), _vm._v(" " + _vm._s(form.cninsurance_form_ref))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("Date Submitted:")]), _vm._v(" " + _vm._s(form.cninsurance_form_reg_date))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.4"
      }
    }, [_c('b', [_vm._v("Form Status:")]), _vm._v(" " + _vm._s(form.cninsurance_form_sent_status_name))]), _vm._v(" "), (form.cninsurance_form_pay_status == 1) ? _c('p', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('b', [_vm._v("Payment Status:")]), _vm._v(" Paid")]) : _c('p', [_c('b', [_vm._v("Payment Status:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Not Paid")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "1em"
      }
    }, [(((form.cninsurance_form_pay_status == 0) || (form.cninsurance_form_sent_status != 200))) ? _c('button', {
      staticClass: "col-xs-4 btn btn-default",
      staticStyle: {
        "color": "#ff0000",
        "border-bottom": "#fdcfcf solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setMainView('resubmit', form)
        }
      }
    }, [_vm._v("process form")]) : _vm._e(), _vm._v(" "), (((form.cninsurance_form_pay_status == 1) && (form.cninsurance_form_sent_status == 200))) ? _c('button', {
      staticClass: "col-xs-4 btn btn-default",
      staticStyle: {
        "border-bottom": "#e7c619 solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setMainView('renew_selected', form)
        }
      }
    }, [_vm._v("Renew")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "col-xs-4 pull-right btn btn-default",
      staticStyle: {
        "border-bottom": "#22baae solid",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_form', form, '')
        }
      }
    }, [_vm._v("view")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-left": "1em"
    }
  }, [_vm._v("No Form")])]) : _vm._e(), _vm._v(" "), (_vm.set_main_view.renew && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.current_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.set_main_view.renew_selected && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.set_renew_selected_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.set_main_view.resubmit && (Object.keys(_vm.cninsurance_partner).length !== 0)) ? _c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_partner,
      "cninsurance": _vm.set_submit_form_data_form_entries
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_form",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Form Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_id))])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Number: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_number))])])]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_certificate_url != 'nil') ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "href": _vm.cninsurance_form.cninsurance_form_certificate_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Certificate")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wn-mobi-on"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.toggleView('menu_1')
      }
    }
  }, [_vm._v("Settings "), _c('i', {
    staticClass: "fa fa-gear",
    staticStyle: {
      "font-size": "1.6em",
      "color": "#22baae",
      "font-weight": "bolder"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "menu_1"
    }
  }, [(_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Claims")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Complaints")]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_claim', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Claim")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_complaint', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Complaint")]), _vm._v(" "), ((Object.keys(_vm.set_component_view).length) > 0) ? _c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_component_view = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Back to Form")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right wn-mobi-off"
  }, [(_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_claims', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Claims")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_view_flie_complaints', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("Complaints")]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_policy_id > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_claim', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Claim")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('set_flie_complaint', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("File Complaint")]), _vm._v(" "), ((Object.keys(_vm.set_component_view).length) > 0) ? _c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.set_component_view = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Back to Form")]) : _vm._e()]), _vm._v(" "), (_vm.set_component_view.set_flie_complaint) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE COMPLAINT")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('cninsurance-file-complaint', {
    attrs: {
      "cninsurance": _vm.cninsurance_data
    }
  })], 1)]) : (_vm.set_component_view.set_flie_claim) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE CLAIM")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('cninsurance-file-claim', {
    attrs: {
      "cninsurance": _vm.cninsurance_data
    }
  })], 1)]) : (_vm.set_component_view.set_view_flie_claims) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("CLAIMS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_claim', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : (_vm.set_component_view.set_view_flie_complaints) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("COMPLAINTS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(_vm.cclaim.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setModalContentView('show_complaint', _vm.cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, _vm._l((_vm.cninsurance_form.cninsurance_form_entries), function(cform, cfndex) {
    return _c('div', {
      staticClass: "row"
    }, [((cform.cninsurance_form_entry_type % 2) != 0) ? _c('div', {
      staticClass: "wn-fleft wn-h-list"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(cform.cninsurance_form_entry_value) + "\r\n                                                                                ")])]) : _vm._e(), _vm._v(" "), ((cform.cninsurance_form_entry_type % 2) == 0) ? _c('div', {
      staticClass: "wn-fright wn-h-list"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(cform.cninsurance_form_entry_value) + "\r\n                                                                                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_claim",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Claim Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_claim.cninsurance_claim_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Claim Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_title) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_details) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_reg_date) + "\r\n                                                                                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "show_complaint",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('show_form')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Complaint Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_complaint.cninsurance_complaint_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Complaint Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_title) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_details) + "\r\n                                                                                ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                                                                    " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_reg_date) + "\r\n                                                                                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])]), _vm._v(" "), (Object.keys(_vm.cninsurance_partner).length !== 0) ? _c('div') : _vm._e()])]) : _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No forms yet")]), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.viewAll) ? _c('div', {
    staticClass: "row"
  }) : _vm._e()]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-xs-12 col-lg-3 fld"
  }, [_c('div', {
    staticClass: "sidebar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-table",
    staticStyle: {
      "font-size": "4em",
      "color": "#22baae",
      "font-weight": "bold"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My InsureMoto")]), _vm._v(">\r\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/insuremoto"
    }
  }, [_vm._v("Start Insurance")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19fbb8ce"}!./src/components/Account/CNinsurance/template.html
// module id = 272
// module chunks = 0